import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CarFormDialog from "./CarFormDialog";
import DriverSelectDialog from "./DriverSelectDialog";

function CarSelectDialog({
  open,
  onClose,
  onSuccess,
  customerData,
  fetchData,
}) {
  const [openAddCarDialog, setOpenAddCarDialog] = useState(false);

  const [openDriverDialog, setOpenDriverDialog] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);

  // เมื่อคลิกรถ -> เปิด dialog เลือกคนขับ
  const handleCarClick = (car) => {
    setSelectedCar(car);
    setOpenDriverDialog(true);
  };

  const handleCarSkip = () => {
    onSuccess &&
      onSuccess({
        car: [],
        drive: [],
        customer: customerData,
      });
    onClose && onClose();
  };

  const handleDriverPicked = (driver) => {
    onSuccess &&
      onSuccess({
        car: selectedCar,
        driver,
        customer: customerData,
      });

    // ปิด dialog ทั้งคู่
    setOpenDriverDialog(false);
    onClose && onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display={"flex"} justifyContent={"space-between"}>
            เลือกรถของ {customerData?.name || "-"}
            <Button onClick={() => setOpenAddCarDialog(true)}>
              เพิ่มข้อมูลรถ
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent>
          {customerData?.cars?.length ? (
            <Grid container spacing={2}>
              {customerData.cars.map((car) => (
                <Grid item xs={12} sm={4} md={3} key={car.id}>
                  <Card
                    variant="outlined"
                    sx={{ cursor: "pointer", "&:hover": { boxShadow: 3 } }}
                    onClick={() => handleCarClick(car)}
                  >
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {car.type || "-"}
                      </Typography>
                      <Box display="flex" justifyContent="space-between">
                        <Typography>{car.license || "-"}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {car.province || "-"}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography color="text.secondary">ไม่มีข้อมูลรถ</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            size="large"
            sx={{ width: "100px" }}
            onClick={handleCarSkip}
          >
            ข้าม
          </Button>
          <Button
            variant="contained"
            size="large"
            sx={{ width: "100px" }}
            onClick={onClose}
          >
            ปิด
          </Button>
        </DialogActions>
      </Dialog>

      {/* ฟอร์มเพิ่มรถ */}
      <CarFormDialog
        open={openAddCarDialog}
        onClose={() => setOpenAddCarDialog(false)}
        customerData={customerData}
        onSuccess={() => {
          setOpenAddCarDialog(false);
          fetchData();
        }}
      />

      {/* เลือกคนขับ (จะเปิดหลังจากเลือกรถ) */}
      <DriverSelectDialog
        open={openDriverDialog}
        onClose={() => setOpenDriverDialog(false)}
        customerData={customerData}
        carData={selectedCar}
        onPick={handleDriverPicked}
        onSuccess={() => {
          fetchData();
        }}
      />
    </>
  );
}

export default CarSelectDialog;
